export type PagesSpotlightMaybeInternalProps = { tabData: { url: string | null | undefined } };

export const USER_PROPERTY_KEY = 'horizontal-nav-tabs-pages-spotlight-seen';
